const getters = {
    performanceRecords: (state) => state.performanceRecords,
    performanceRecordId: (state) => state.performanceRecordId,
    loading: state => state.loading
};

export default getters;